export const AUTH_ERRORS = {
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR' as const,
  RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR' as const,
  CONFIRM_PASSWORD_RESET_ERROR: 'CONFIRM_PASSWORD_RESET_ERROR' as const,
  FETCH_ME: 'FETCH_ME' as const,
};
